// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"da2596ab","257":"072b1922","453":"003973c8","732":"9a0e7c30","977":"6fc41d9d"}[chunkId] + ".chunk.js";
};